import { LayoutContainer } from 'components/Layout';
import { type FieldKey, useIsCompanySite } from 'hooks';
import type { FooterLinkField, IconLinkField } from 'models/sitecore';
import type { TemplateString } from 'types';
import { cn } from 'utils/classNames';

import { flattenFooterLinks } from './helpers';
import PageFooterLinks from './PageFooterLinks';
import PageFooterSocial from './PageFooterSocial';

interface Props {
	companyName: string;
	followUsLabel: TemplateString | FieldKey;
	links: FooterLinkField[];
	socialMediaLinks: IconLinkField[];
}

/** Secondary area with socials and other links. */
export default function PageFooterSecondary({
	companyName,
	followUsLabel,
	links,
	socialMediaLinks,
}: Props) {
	const linkData = flattenFooterLinks(links);
	const isCompanySite = useIsCompanySite();

	return (
		<LayoutContainer
			outerClassName={cn(
				'flex min-h-14 items-center py-1 text-negative forced-colors:border-t',
				isCompanySite ? 'bg-brandDecorative' : 'bg-positive',
			)}
			innerClassName="w-full md:flex md:items-center"
		>
			<div className="flex shrink-0 items-center justify-between max-md:min-h-12">
				<p>
					© {new Date().getFullYear()} {companyName}
				</p>
				<PageFooterSocial
					followUsLabel={followUsLabel}
					links={socialMediaLinks}
					className="md:hidden"
				/>
			</div>
			<PageFooterLinks
				links={linkData}
				className="flex grow flex-wrap gap-x-6 gap-y-2 pb-3 md:justify-center md:px-8 md:py-2"
			/>
			<PageFooterSocial
				followUsLabel={followUsLabel}
				links={socialMediaLinks}
				className="max-md:hidden"
			/>
		</LayoutContainer>
	);
}
PageFooterSecondary.displayName = 'PageFooterSecondary';
